/* ========================================================================
   INFORMATIONS GÉNÉRALES SUR LE SITE
   Propriété de © 2019/2024 Shopiweb.fr
   Pour plus d'informations, visitez : https://www.shopiweb.fr
   ------------------------------------------------------------------------
   LPFR : dans le panneau « Mes favoris », le formulaire d'ajout au panier
   est remplacé par un bouton « Voir le produit » (les champs obligatoires
   des fiches — taille, chaîne — étaient contournés). Le bouton de
   suppression est stylisé en pastille corbeille visible à côté.
   ======================================================================== */

const localStorageKey = "shopiweb_wishlist_v1";

/* =====================
   Retirer de la liste de souhaits
   ===================== */
window.handleWishlistItemRemoval = (btn) => {
  let wishlist = JSON.parse(localStorage.getItem(localStorageKey)) || [];

  wishlist = wishlist.filter(
    (elem) => elem.handle !== btn.dataset.productHandle
  );

  localStorage.setItem(localStorageKey, JSON.stringify(wishlist));

  initializeWishlist();
};

/* =====================
   Ajouter ou retirer de la liste de souhaits
   ===================== */
window.removeOrAddFromWishlist = async (btn) => {
  let wishlist = JSON.parse(localStorage.getItem(localStorageKey)) || [];
  const isWishlisted = wishlist.some(
    (elem) => elem.handle === btn.dataset.productHandle
  );

  if (isWishlisted) {
    wishlist = wishlist.filter(
      (elem) => elem.handle !== btn.dataset.productHandle
    );
  } else {
    const response = await fetch(`/products/${btn.dataset.productHandle}.js`);
    const product = await response.json();

    const variants = product.variants.map((variant) => ({
      id: variant.id,
      title: variant.title,
      compare_at_price: variant.compare_at_price,
      price: variant.price,
      featured_image: {
        src: variant.featured_image?.src || null,
      },
    }));

    wishlist.push({
      id: product.id,
      handle: product.handle,
      url: product.url,
      title: product.title,
      compare_at_price: product.compare_at_price,
      price: product.price,
      price_varies: product.price_varies,
      featured_image: product.featured_image,
      vendor: product.vendor,
      time: Date.now(),
      variants,
    });
  }

  localStorage.setItem(localStorageKey, JSON.stringify(wishlist));

  initializeWishlist();
};

/* =====================
   Initialisation liste de souhaits
   ===================== */
const initializeWishlist = () => {
  const wishlist = JSON.parse(localStorage.getItem(localStorageKey)) || [];

  document.querySelectorAll(".btn-wishlist-add-remove").forEach((btn) => {
    const isWishlisted = wishlist.some(
      (elem) => elem.handle === btn.dataset.productHandle
    );

    if (isWishlisted) {
      btn.querySelector("svg").setAttribute("fill", "currentColor");
      btn.setAttribute("aria-label", btn.dataset.textRemove);
      btn.classList.add("is-wishlisted");
    } else {
      btn.querySelector("svg").setAttribute("fill", "none");
      btn.setAttribute("aria-label", btn.dataset.textAdd);
      btn.classList.remove("is-wishlisted");
    }
  });

  document.querySelectorAll(".wishlist-count-badge").forEach((badge) => {
    if (wishlist.length === 0) {
      badge.setAttribute("hidden", "hidden");
    } else {
      badge.removeAttribute("hidden");
      badge.textContent = wishlist.length;
    }
  });

  if (wishlist.length) {
    const productList = document.querySelector(
      "#offcanvas-wishlist-product-listing"
    );
    let productListItems = "";

    wishlist.forEach((product) => {
      productListItems += `
                <li class="product-item py-3">
                    <div class="row align-items-center mx-n3">
                        <div class="col-4 px-3">
                            <a class="" href="${product.url}" tabindex="-1">
                                <img 
                                    class="product-item-img img-fluid rounded ${
                                      productList.dataset.imgThumbnail
                                    }" 
                                    src="${Shopify.resizeImage(
                                      product.featured_image || "no-image.gif",
                                      `${productList.dataset.imgWidth}x${productList.dataset.imgHeight}`,
                                      "center"
                                    )}"
                                    alt="" 
                                    width="${productList.dataset.imgWidth}"
                                    height="${productList.dataset.imgHeight}"
                                    loading="lazy">
                            </a>
                        </div>
                        <div class="col-8 px-3">
                            <h3 class="product-item-title h6 mb-0">
                                <a href="${product.url}" class="link-dark">
                                    ${product.title}
                                </a>
                            </h3>
                            <div class="stp-star mb-3"
                               data-id="${product.id}">
                            </div>
                            <p class="product-item-price small mb-3">
                                <span ${
                                  product.compare_at_price > product.price
                                    ? ""
                                    : "hidden"
                                }>
                                    <span class="product-item-price-final me-1">
                                        <span class="visually-hidden">
                                            ${
                                              productList.dataset.textPriceSale
                                            } &nbsp;
                                        </span>
                                        <span ${
                                          product.price_varies ? "" : "hidden"
                                        }>
                                            ${productList.dataset.textPriceFrom}
                                        </span>
                                        ${Shopify.formatMoney(product.price)}
                                    </span>
                                    <span class="product-item-price-compare text-muted">
                                        <span class="visually-hidden">
                                            ${
                                              productList.dataset
                                                .textPriceRegular
                                            } &nbsp;
                                        </span>
                                        <s>
                                            ${Shopify.formatMoney(
                                              product.compare_at_price
                                            )}
                                        </s>
                                    </span>
                                </span>
                                <span class="product-item-price-final" ${
                                  product.compare_at_price > product.price
                                    ? "hidden"
                                    : ""
                                }>
                                    <span ${
                                      product.price_varies ? "" : "hidden"
                                    }>
                                        ${productList.dataset.textPriceFrom}
                                    </span>
                                    ${Shopify.formatMoney(product.price)}
                                </span>
                            </p>
                            <div style="display:flex; align-items:center; gap:10px;">
                                <a 
                                    class="btn btn-sm btn-primary px-4"
                                    href="${product.url}">
                                    Voir le produit
                                </a>
                                <button 
                                    style="display:inline-flex; align-items:center; justify-content:center; width:34px; height:34px; flex-shrink:0; background:#ffffff; border:1px solid #e6e6e6; border-radius:50%; color:#b02a37; padding:0; cursor:pointer; box-shadow:0 1px 3px rgba(0,0,0,.08);"
                                    data-product-handle="${product.handle}"
                                    onclick="handleWishlistItemRemoval(this)"
                                    title="${
                                      productList.dataset.textWishlistRemove
                                    }"
                                    aria-label="${
                                      productList.dataset.textWishlistRemove
                                    }">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </li>
            `;
    });
    productList.innerHTML = productListItems;

    window.SPR?.initDomEls();
    window.SPR?.loadBadges();

    document
      .querySelector("#offcanvas-wishlist-empty")
      .setAttribute("hidden", "hidden");
    document
      .querySelector("#offcanvas-wishlist-product-listing")
      .removeAttribute("hidden");
  } else {
    document
      .querySelector("#offcanvas-wishlist-empty")
      .removeAttribute("hidden");
    document
      .querySelector("#offcanvas-wishlist-product-listing")
      .setAttribute("hidden", "hidden");
    document.querySelector("#offcanvas-wishlist-product-listing").innerHTML =
      "";
  }
};
initializeWishlist();

window.addEventListener("updated.shopiweb.cart", initializeWishlist);
window.addEventListener("onCollectionShopiwebUpdate", initializeWishlist);
window.addEventListener(
  "init.shopiweb.recommended_products",
  initializeWishlist
);
